import { CONTACT_ADMINISTRATOR_MESSAGE } from '@emmacare/common/api/httpClient'

export const BROKEN_LINK_MESSAGE = `The link is broken. ${CONTACT_ADMINISTRATOR_MESSAGE}`

export const FETCHING_USER_DATA_ERROR_MESSAGE = `Server Error! Was unable to fetch required user data. ${CONTACT_ADMINISTRATOR_MESSAGE}`

export const FORM_REQUIREMENT_MESSAGE = 'Please, fill in all required fields'

export const USERNAME_REQUIREMENT_MESSAGE = 'Username is required'
export const PASSWORD_REQUIREMENT_MESSAGE = 'Password is required'

export const REASON_REQUIREMENT_MESSAGE = 'Reason is required!'
export const END_DATE_REQUIREMENT_MESSAGE = 'End date is required!'

export const START_DATE_REQUIREMENT_MESSAGE = 'Start date is required!'
export const CONSENT_DATE_REQUIREMENT_MESSAGE = 'Consent date is required!'
export const PROGRAM_TYPE_REQUIRED_MESSAGE = 'Program type is required!'
export const DATE_REQUIREMENT_MESSAGE = 'Date is required!'
export const DATE_RANGE_REQUIREMENT_MESSAGE = 'Dates are required!'
export const USER_REQUIREMENT_MESSAGE = 'User is required!'

export const NOTE_REQUIREMENT_MESSAGE = 'Note is required!'
export const INVALID_PHONE_NUMBER_MESSAGE = 'Phone number is invalid.'

export const COMMENT_REQUIREMENT_MESSAGE = 'Comment is required!'

export const EMAIL_REQUIREMENT_MESSAGE = 'Email is required'
export const INVALID_EMAIL_MESSAGE =
  'Allowed only latin letters, digits, dots, special chars!'
export const EMAIL_ERROR_MESSAGE = 'Invalid email value.'

export const SUCCESS_EMAIL_VALIDATION_MESSAGE =
  'If a matching email is found, reset instructions will be sent to your email.'
export const SUCCESS_EMAIL_MATCHING_MESSAGE =
  'Email will be sent to you with the details to access your account again.'

export const INCORRECT_PASSWORD_MESSAGE = 'Incorrect password'
export const CONFIRMATION_PASSWORD_MESSAGE = 'Password confirmation is required'

export const INCORRECT_PASSWORD_CONFIRM_MESSAGE =
  'Password entries do not match'
export const UPDATED_PASSWORD_MESSAGE = 'Password has been updated.'

export const SET_PASSWORD_MESSAGE = 'Password has been set.'

export const PATHWAY_REQUIREMENT_MESSAGE = 'EPROM is required!'
export const DISEASES_REQUIREMENT_MESSAGE = 'Diseases are required!'
export const CHECK_IN_REQUIREMENT_MESSAGE = 'Check in is required!'
export const QUESTION_REQUIREMENT_MESSAGE = 'Question is required!'
export const ANSWER_REQUIREMENT_MESSAGE = 'Answer is required!'
export const NUMBER_RANGE_ERROR_MESSAGE = 'Number should be in range 0-99999!'
export const NUMBER_FLOAT_FORMAT_ERROR_MESSAGE =
  'Format is not correct, only two numbers are supported with . separator.'
export const ONE_NUMBER_FLOAT_FORMAT_ERROR_MESSAGE =
  'Format is not correct, only one number are supported with . separator.'
export const NUMBER_SIX_DIGITS_RANGE_VALIDATION_MESSAGE =
  'Number should be in range 0-999999.'

export const GO_BACK_WARNING_MESSAGE =
  'Are you sure that you want to go back? You may lose data.'
export const SWITCH_NEW_TAB_WARNING_MESSAGE =
  'Are you sure that you want to switch tab? You may lose data.'

export const PATHWAY_SUCCESS_SAVE_MESSAGE = 'EPROM successfully saved'
export const PATHWAY_RESPONSE_SUCCESS_SAVE_MESSAGE =
  'Response successfully saved!'
export const PATHWAY_INACTIVE_MESSAGE = 'Change patient EPROM status to'
export const PATHWAY_ONE_ANSWER_ERROR_MESSAGE =
  'At least one question should be answered.'

export const SOFT_CURRENCY_INVALID_MESSAGE = 'Soft currency value is invalid.'
export const HARD_CURRENCY_INVALID_MESSAGE = 'Hard currency value is invalid.'

export const CURRENCY_INVALID_MESSAGE = 'Currency value is invalid'
export const REDEMPTION_BALANCE_INVALID_MESSAGE =
  'Redemption balance value is invalid'

export const ACHIEVEMENT_SUCCESS_SAVE_MESSAGE =
  'Achievement successfully saved!'
export const SHOP_ITEM_SUCCESS_SAVE_MESSAGE = 'Shop item successfully saved!'
export const NO_PRIMARY_ADDRESS = 'Primary address field is not set.'

export const REFERRAL_DUPLICATE_MESSAGE =
  'A similar patient/referral already exists. Please check to ensure your new referral is not a duplicate.'
export const PATIENT_DUPLICATE_MESSAGE =
  'A similar patient/referral already exists. Please check to ensure your new patient is not a duplicate.'
export const REFERRAL_SUBGROUP_DUPLICATE_MESSAGE =
  'This sub-group is already added to the list.'
export const REFERRAL_NOTE_TEXT_INVALID_MESSAGE =
  'Text is too long, no more than 10000 symbols are allowed.'

export const CASEMANAGERS_ALERT_TEXT_LENGTH_MESSAGE =
  'Text is too long, no more than 2048 symbols are allowed.'
export const VERY_LONG_TEXT_INVALID_MESSAGE =
  'Text is too long, no more than 1000 symbols are allowed.'
export const LONG_TEXT_INVALID_MESSAGE =
  'Text is too long, no more than 255 symbols are allowed.'
export const MEDIUM_TEXT_INVALID_MESSAGE =
  'Text is too long, no more than 127 symbols are allowed.'
export const SHORT_TEXT_INVALID_MESSAGE_OPIONAL =
  'Optional · max 100 characters'
export const DYNAMIC_TEXT_INVALID_MESSAGE = (max = 127) =>
  `Text is too long, no more than ${max} symbols are allowed.`

export const REF_REQUIRED_MESSAGE = 'Reference is required.'
export const FIVE_DIGITS_MESSAGE = 'Text must contain 5 digits.'
export const TEN_DIGITS_MESSAGE = 'Text must contain 10 digits.'

export const DESCRIPTION_500_INVALID_MESSAGE =
  'Description cannot be longer than 500 characters'
export const TEXT_500_INVALID_MESSAGE =
  'Text cannot be longer than 500 characters.'
export const TWO_THOUSAND_SYMBOLS_LIMIT_MESSAGE =
  'Text cannot be longer than 2000 characters'
export const FIVE_THOUSAND_SYMBOLS_LIMIT_MESSAGE =
  'Text cannot be longer than 5000 characters'
export const SIX_THOUSAND_SYMBOLS_LIMIT_MESSAGE =
  'Text cannot be longer than 6000 characters'
export const FIFTEEN_THOUSAND_SYMBOLS_LIMIT_MESSAGE =
  'Text cannot be longer than 15000 characters'

// @todo: Make dynamic with char count...
export const NAME_50_INVALID_MESSAGE =
  'Name cannot be longer than 50 characters'
export const NAME_100_INVALID_MESSAGE =
  'Name cannot be longer than 100 characters'
export const TEXT_50_INVALID_MESSAGE =
  'Text cannot be longer than 50 characters'

export const LICENSES_SUCCESS_SAVE_MESSAGE = 'Licenses are successfully saved!'
export const DESCRIPTION_IS_REQUIRED_MESSAGE = 'Description is required!'
export const ACTIVITY_TYPE_IS_REQUIRED_MESSAGE = 'Activity type is required'

export const SECTION_NO_ACCESS_MESSAGE =
  'You don’t have permission to access this section.'
export const CLINICAL_PATHWAY_CONDITION_DELETE_MESSAGE =
  'By deleting this record all conditional questions/answered related to that question will be deleted as well. Are you sure you want to proceed?'
export const CHAT_DISABLE_MESSAGE = 'Chat module is disabled.'
export const GAMIFICATION_DISABLE_MESSAGE =
  'Points & Rewards module is disabled'
export const TELEMEDICINE_IS_DISABLED = 'Telemedicine module is disabled.'
export const URGENT_CARE_IS_DISABLED = 'Urgent Care module is disabled.'

export const PATIENT_IS_REQUIRED_MESSAGE = 'Patient is required'
export const DURATION_VALIDATION_MESSAGE = 'Duration is not valid'

export const DATE_IS_REQUIRED_MESSAGE = 'Date is required'
export const TIME_IS_REQUIRED_MESSAGE = 'Time is required'
export const TIME_IN_PAST_MESSAGE = 'You cannot select past time.'
export const TIME_WRONG_FORMAT_MESSAGE = 'Wrong time format.'

export const MEASUREMENT_REQUIRED_MESSAGE = 'Measurement is required.'
export const MEASUREMENT_PATIENT_READING_MESSAGE =
  'Reading was successfully sent to patient.'
export const MEASUREMENT_PATIENT_INACTIVE_MESSAGE =
  'Change patient measurement status to'
export const MEASUREMENT_PATIENT_SUCCESS_SAVE_MESSAGE =
  'Measurement successfully saved'
export const MEASUREMENT_PATIENT_ANSWER_SUCCESS_SAVE_MESSAGE =
  'Patient answer has been successfully saved!'
export const MEASUREMENT_PATIENT_SYNC_DEVICE_MESSAGE =
  'Do you want to sync all third-party patient devices? We will notify you about the result.'

export const FIELD_REQUIRED_MESSAGE = 'Field is required.'
export const FIELD_INVALID_MESSAGE = 'Field is invalid.'
export const WRONG_FIELD_VALUE_MESSAGE = 'Wrong field value.'
export const FIELD_UNIQUE_VALUE_MESSAGE = 'Value must be unique.'
export const FIELD_EMAIL_UNIQUE_VALUE_MESSAGE = 'Email must be unique.'
export const NO_ENROLLED_PROGRAM_MESSAGE = 'Patient has no enrolled program'
export const FOUR_DIGITS_ERROR_MESSAGE = 'Please enter four digits.'

export const FROM_ONE_TO_TEN_MESSAGE = 'Value must be between 1 - 10.'
export const FROM_ONE_TO_TWENTY_MESSAGE = 'Value must be between 1 - 20.'
export const FROM_ONE_TO_YEAR_MESSAGE = 'Value must be between 1 - 365.'
export const FROM_ONE_TO_NINETY_NINE_MESSAGE = 'Value must be between 1 - 99.'
export const FROM_ONE_TO_HUNGRED_MESSAGE = 'Value must be between 1 - 100.'
export const FROM_ONE_TO_THOUSAND_MESSAGE = 'Value must be between 1 - 1000.'
export const FROM_ZERO_TO_THIRTY_MESSAGE = 'Value must be between 0 - 30.'
export const FROM_ZERO_TO_NINE_HUNGRED_NINETY_NINE_MESSAGE =
  'Value must be between 0 - 999.'
export const FROM_ZERO_TO_FIFTY_NINE_MESSAGE = 'Value must be between 0 - 59.'

export const BILLING_BATCH_QUEUED_MESSAGE =
  'Your billing batch has been queued for processing.'
export const INVOICE_UNBILLING_CONFIRM_MESSAGE = 'Are you sure?'

export const BROADCAST_SUCCESS_SAVE_MESSAGE =
  'Broadcast has been successfully saved!'
export const BROADCAST_SUCCESS_DELETE_MESSAGE =
  'Broadcast has been successfully deleted!'
export const BROADCAST_MESSAGE_SUCCESS_SAVE_MESSAGE =
  'Message has been successfully saved!'
export const BROADCAST_MESSAGE_SUCCESS_DELETE_MESSAGE =
  'Message has been successfully deleted!'

export const MEDICATION_SAVE_MESSAGE = 'Medication has been successfully saved!'
export const MEDICATION_DELETE_MESSAGE =
  'Medication has been successfully deleted!'
export const INTAKE_SAVE_MESSAGE = 'Intake has been successfully saved!'
export const INTAKE_DELETE_MESSAGE = 'Intake has been successfully deleted!'

export const GOAL_SAVE_MESSAGE = 'Goal has been successfully saved!'
export const GOAL_DELETE_MESSAGE =
  'Goal {:title} has been successfully deleted!'
export const GOAL_CONFIRM_DELETE_MESSAGE =
  'Are you sure you want to delete that goal?'
export const GOAL_TOOLTIP_TITLE_MESSAGE = "Goal title can't be changed."
export const GOAL_TOOLTIP_CATEGORY_MESSAGE = "Goal category can't be changed."
export const INTERVENTION_AVAILABLE_MESSAGE = 'Available only for active goals.'
export const INTERVENTION_SAVE_MESSAGE =
  'Intervention has been successfully saved!'
export const INTERVENTION_DELETE_MESSAGE =
  'Intervention {:title} has been successfully deleted!'
export const INTERVENTION_CONFIRM_DELETE_MESSAGE =
  'Are you sure you want to delete that intervention?'
export const INTERVENTION_TOOLTIP_TITLE_MESSAGE =
  "Intervention title can't be changed."
export const INTERVENTION_TOOLTIP_CATEGORY_MESSAGE =
  "Intervention category can't be changed."

export const GET_ACTIVE_TIMER_INFO_MODAL = (patient = '', time = '') =>
  `Your timer is running for ${time} min for patient ${patient}`

export const BILLING_NOT_AVAILABLE_MESSAGE =
  'Your Billing would be active after the first month of the platform usage.'

export const ONLY_LETTERS_ERROR_MESSAGE =
  'Allowed only latin letters and space.'
export const BILLING_CONFIRMATION_MESSAGE = (patients = 0) =>
  `Invoices will be created for ${patients} patient${patients > 1 ? 's' : ''}`

export const COMPANY_NAME_IS_REQUIRED_MESSAGE = 'Company name is required!'
export const COMPANY_GOAL_IS_REQUIRED = 'Company goal category is required!'
export const TIMEZONE_IS_REQUIRED_MESSAGE = 'Time zone is required!'
export const INCORRECT_EMAIL_MESSAGE = 'Email is incorrect'
export const INCORRECT_EMAIL_DUPLICATE_MESSAGE =
  'This email is already added to the list'
export const INCORRECT_EMAIL_WITH_SAMPLE_MESSAGE =
  'Email format is incorrect. Example of a valid email: name@example.com'
export const LANGUAGE_IS_REQUIRED_MESSAGE = 'Language is required!'
export const TYPE_IS_REQUIRED_MESSAGE = 'Type is required!'
export const FIELD_IS_LONG_MESSAGE = 'Max length is 255 symbols.'

export const CM_NAME_IS_LONG_MESSAGE = "Field's max length is 255 symbols"

export const REMOVE_DEVICE_ID_MESSAGE = 'Do you want to remove device ID?'
export const GET_APP_LINK_MESSAGE = `Do you want to send Application Install Links to the Patient's mobile device?`

export const REMOVE_PATIENT_DOCUMENT_MESSAGE =
  'Do you want to remove the document?'
export const SET_CONSENT_DATE_MESSAGE = 'Please set consent date first!'

export const DISEASE_IS_REQUIRED_MESSAGE = 'Problem is required!'
export const WRONG_FILE_SIZE_MESSAGE = (maxSize = '') =>
  `Your file cannot be uploaded because it exceeds the size limit of ${maxSize}. Please choose a smaller file or reduce the file size and try again.`
export const WRONG_FILE_FORMAT_MESSAGE = 'Wrong file format!'
export const CONVERSATION_FILE_FORMAT_OR_SIZE_ERROR_MESSAGE =
  'Wrong file format or image size more than 3Mb!'

export const CHANGE_PRIMARY_DISEASE_CONFIRM_MESSAGE = (
  newDis = '',
  oldDis = ''
) => `Set ${newDis} as primary problem instead of ${oldDis}`
export const CHANGE_PRIMARY_DIAGNOSIS_CONFIRM_MESSAGE = (
  newDia = '',
  oldDia = '',
  isPrimary = false
) =>
  `Set ${newDia} as ${
    isPrimary ? 'primary' : 'secondary'
  } diagnosis instead of ${oldDia}`

export const GET_UNLOCK_USER_MESSAGE = (user = '') =>
  `You are about to unlock user ${user}. Do you want to proceed?`

export const GET_ADD_NEW_MEDICATION_MESSAGE = (value = '') =>
  `Your medication (${value}) was not found in our database. Do you want to add it as a new medication?`

export const CREATE_ACTIVE_USER_MESSAGE =
  'You are about to create an active user. The user will receive a registration email with instructions on how to setup their initial password.'
export const CREATE_INACTIVE_USER_MESSAGE =
  'You are about to create an inactive user. An activation email will be sent once the Pending Users Administrator activates the user.'

export const GET_RESTORE_PASSWORD_MESSAGE = (user = '') =>
  `You are about to send a reset password email to User ${user}. Do you want to proceed?`
export const GET_INACTIVATE_CASE_MANAGER_MESSAGE = (cm = '') =>
  `You are about to inactivate user ${cm}. Do you want to proceed?`

export const COURSE_SAVE_MESSAGE = 'Course has been successfully saved!'
export const COURSE_RESET_MESSAGE = 'Course has been successfully reset!'
export const CUSTOM_DOSAGE_VALIDATION_MESSAGE =
  'Can not be longer than 255 chars'

export const REMOVE_FOLLOW_UP_CALL_MESSAGE =
  'Do you want to remove follow up call date?'
export const GET_EXPIRATION_PASSWORD_MESSAGE = (days = 0) =>
  `Your password will expire in ${days} day${
    days > 1 ? "'s" : ''
  }. Click 'Change now' to change it`
export const LESS_DAY_EXPIRATION_PASSWORD_MESSAGE =
  "Your password will expire in less than a day. Click 'Change now' to change it."

export const PATIENT_CLINICIAN_CHANGE_CONFIRM_MESSAGE =
  'Do you want to re-assign scheduled appointments to a new clinician?'
export const UNLOCK_PATIENT_CONFIRM_MESSAGE =
  'Do you want to unlock this patient?'
export const UNLOCK_PATIENT_MESSAGE = 'Patient has been unlocked.'

export const SERVICE_HISTORY_INFO_MESSAGE = 'Please select patients.'
export const DEVICE_TYPE_IS_REQUIRED_MESSAGE = 'Device type is required!'

export const PATIENT_NO_DISEASES_MESSAGE =
  "Patient doesn't have any assigned problem."
export const PATIENT_SET_PRIMARY_DISEASE_MESSAGE = `You must first have a primary problem before adding a {:îtem}. Go to Enrolled Program --> Problem list to add a problem.`

export const BILLING_TYPE_IS_REQUIRED_MESSAGE = 'Billing program is required'
export const BILLING_CODE_BILLED_MESSAGE =
  'Patient was already billed for {:billingCode} in the past. Are you sure you would like to bill it again? This could lead to a rejected claim.'
export const NO_BILLING_PROGRAMS_MSG =
  'Patient is not enrolled to CCM or RPM program'

export const EXPORT_INFO_MESSAGE =
  'System will export all compliant records for the selected month irrespectively of the selected filters.'

export const CLINICIAN_IS_REQUIRED_MESSAGE = 'Clinician is required'

export const DIAGNOSIS_SELECT_MESSAGE = 'Select diagnosis from list.'
export const DELETE_SCHEDULED_APPOINTMENT_CONFIRM_MESSAGE =
  'Are you sure you want to delete the scheduled appointment?'
export const DELETE_COMPLETED_APPOINTMENT_CONFIRM_MESSAGE =
  'Are you sure you want to delete the completed appointment?'
export const DELETE_MISSED_APPOINTMENT_CONFIRM_MESSAGE =
  'Are you sure you want to delete the missed appointment?'
export const APPOINTMENT_SEND_NOTIFICATION_CONFIRM_MESSAGE =
  'Would you like to send an update notification to the call recipient about the appointment change?'
export const APPOINTMENT_SEND_NOTIFICATION_CANCELED_CONFIRM_MESSAGE =
  'Would you like to send an update notification to the previous and new call recipients about the appointment change?'
export const APPOINTMENT_NO_PHONE_INFO_MESSAGE =
  'There is no patient or caregiver phone number. Note that invitation link should be sent separately.'

export const DELETE_RIBBON_CONFIRM_MESSAGE =
  'Are you sure you want to delete the ribbon?'

export const CAREGIVER_MANAGEMENT_NEXT_STEP_MESSAGE =
  'Create Caregiver before adding an address.'
export const CAREGIVER_MANAGEMENT_SAVE_MESSAGE =
  'Caregiver has been successfully saved!'
export const CAREGIVER_MANAGEMENT_UPDATE_MESSAGE =
  'Caregiver has been successfully updated!'
export const CAREGIVER_MANAGEMENT_DISABLE_MESSAGE =
  'Caregiver has been successfully disabled!'
export const CAREGIVER_MANAGEMENT_ADDRESS_SAVE_MESSAGE =
  'Caregiver address has been successfully saved!'
export const CAREGIVER_MANAGEMENT_ADDRESS_UPDATE_MESSAGE =
  'Caregiver address has been successfully updated!'
export const CAREGIVER_MANAGEMENT_CONFIRM_ENABLE_MESSAGE =
  'Are you sure you want to enable {:fullName}?'
export const CAREGIVER_MANAGEMENT_CONFIRM_DISABLE_MESSAGE =
  'Are you sure you want to disable {:fullName}?'
export const CAREGIVER_MANAGEMENT_CONFIRM_DELETE_MESSAGE =
  'Are you sure you want to remove Facility {:name} from the assigned facilities?'
export const CAREGIVER_MANAGEMENT_SMS_MESSAGE =
  'SMS to caregiver has been successfully sended!'

export const CAREGIVER_MANAGEMENT_PATIENTS_ADD_MESSAGE =
  'Patient(s) has been successfully assigned.'
export const CAREGIVER_MANAGEMENT_PATIENTS_DELETE_MESSAGE =
  'Patient(s) has been successfully unassigned.'
export const CAREGIVER_MANAGEMENT_RESET_SELECTION_MESSAGE =
  'Your selection will be disregarded. Do you want to move to proceed?'
export const CAREGIVER_MANAGEMENT_FACILITIES_ADD_MESSAGE =
  'Facilities has been successfully assigned.'
export const CAREGIVER_MANAGEMENT_FACILITIES_DELETE_MESSAGE =
  'Facilities has been successfully unassigned.'

export const ASSIGNED_CAREGIVER_SAVE_MESSAGE =
  'Caregiver has been successfully assigned to patient!'
export const ASSIGNED_CAREGIVER_UPDATE_MESSAGE =
  'Assigned caregiver has been successfully updated!'
export const ASSIGNED_CAREGIVER_DELETE_MESSAGE =
  'Assigned caregiver has been successfully deleted!'
export const ASSIGNED_CAREGIVER_CONFIRM_DELETE_MESSAGE = `Are you sure you want to remove {:fullName}?`

export const NPI_INVALID_MESSAGE = 'NPI should be 10 digits number!'
export const CLINICIAN_JOINED_ERROR_MESSAGE =
  'Another user has already joined the call.'
export const CLINICIAN_LEAVE_CALL_MESSAGE =
  'Are you sure you want to leave the call?'
export const CLINICIAN_END_CALL_MESSAGE =
  'Are you sure you want to end the call?'

export const PATIENT_SELECT_MESSAGE = 'Please select patient from list.'

export const ZIP_CODE_ERROR_MESSAGE = 'ZIP must contain 5 digits.'
export const FAX_ERROR_MESSAGE = 'Fax number is invalid.'
export const NPI_ERROR_MESSAGE = 'NPI must contain 10 digits.'

export const VALUE_IN_RANGE_ERROR_MESSAGE = `Value must be between {:min} - {:max}. `
export const EMPTY_REMINDERS_ERROR_MESSAGE = 'Please set reminder(s).'
export const EMPTY_DAYS_AND_MINUTES_ERROR_MESSAGE =
  'Please set days or minutes.'
export const EQUAL_TO_FIVE_ERROR_MESSAGE = 'The value should be multiples to 5.'

export const PROVIDER_MANAGMENT_SAVE_MESSAGE =
  'Provider has been successfully saved!'
export const PROVIDER_MANAGMENT_UPDATE_MESSAGE =
  'Provider has been successfully updated!'
export const PROVIDER_MANAGMENT_DELETE_MESSAGE =
  'Provider has been successfully deleted!'

export const CONFIRM_ITEM_DELETE_MESSAGE =
  'Are you sure you want to delete {:name}?'

export const ZOMBIE_ALERT_TOOLTIP_MESSAGE =
  'Original value was changed by user. Record might not be correct anymore.'

export const NOT_ENOUGH_DISIASES =
  'Warning: CCM billing requires at least 2 chronic conditions.'
export const NOT_ENOUGH_DAYS_OF_SERVICE =
  'Less than 16 days of service in the month.'
export const NOT_ENOUGH_RPM_DAYS_OF_SERVICE =
  'Must have at least 16 days of RPM for billing.'
export const NOT_ENOUGH_FREQUENCY_DAYS =
  "WARNING: your frequency won't allow you to bill for RPM."

export const PATIENT_ENROLLED_PROGRAM_ROLLBACK_MESSAGE =
  'This action re-activates the patient Enrolment/Program. Do you want to proceed?'
export const TCM_ROLLBACK_NON_BILLABLE_MESSAGE =
  'Activity Log entries and TCM telemedicine calls dated during this TCM program period were marked as non-billable. Their TCM billing codes (99495 and 99496) were removed.'
export const PATIENT_ENROLLED_PROGRAM_RPM_WARNING =
  'WARNING: you are having 2 periods during the same 30 days. You should not bill for more than 1 service per 30 days.'
export const WRONG_MINUTES_FORMAT =
  'For the minute field you can only enter 00, 15, 30 or 45.'
export const DEVICE_ID_IS_REQUIRED_MESSAGE = 'Device ID is required!'

export const INVALID_TIME_FORMAT = 'Invalid time format!'

export const PATIENT_EXTERNAL_DOCUMENT_SUCCESS_UPLOAD_MESSAGE =
  'Document successfully uploaded.'
export const PATIENT_EXTERNAL_DOCUMENT_SUCCESS_DELETE_MESSAGE =
  'Document successfully deleted.'

export const PATIENT_DELETE_MESSAGE = 'Patient has been successfully deleted!'

export const NO_GOALS_MESSAGE =
  'Patient has no user-generated goals. Note that interventions can not be added to system generated goals.'
export const DELETE_TIMER_MESSAGE =
  'Are you sure you want to delete this activity?'

export const CARE_PLAN_REVIEW_DELETE_MESSAGE =
  'Review {:title} has been successfully deleted!'
export const CARE_PLAN_GOALS_INTERVENTIONS_GAPS_MESSAGE =
  "You can't save as there is incomplete data. Add the value between the  ##    ##"

export const TEMPLATE_GENERATOR_NARRATIVE_GAPS_MESSAGE =
  'Please ensure that all placeholders (## ##) contain meaningful content and are not left with only spaces between them.'

export const READING_CHECKIN_INTAKE_MODULE_WARNIG_MESSAGE =
  'Your entry is creating an alert. Do you want to close it?'

export const INITIAL_SETUP_WARNING_MESSAGE =
  'You have a measurement(s) prior to the initial setup date. Are you sure you want to proceed?'

export const US_TIME_FORMAT_REGEXP_MESSAGE = 'Wrong time format.'

export const PATIENT_ON_HOLD_CONFIRM_MESSAGE =
  'You are about to remove the hold status of the patient. Please confirm.'

export const PATIENT_IS_RPM_BILLABLE_CONFIRM_MESSAGE = (checked = false) =>
  `You are about to ${
    checked ? 'add' : 'remove'
  } is RPM billable status of the patient. Please confirm.`

export const GOAL_IS_REQUIRED_MESSAGE = 'Goal is required!'

export const MEASUREMENTS_OVERLAPPING_VALUE_MESSAGE = 'Value is overlapping!'

export const NEW_APPOINTMENT_OVERLAP_WARNING_MESSAGE =
  'Your new appointment is overlapping with an existing appointment. Are you sure you want to proceed?'

export const EXTRA_MODAL_WARNING_MESSAGE =
  'You can only have 1 activity note window open at the same time. Please close the other activity note first.'

export const MEDICAL_EQUIPMENT_SUCCESS_SAVE_MESSAGE =
  'Medical equipment has been successfully saved!'
export const MEDICAL_EQUIPMENT_SUCCESS_DELETE_MESSAGE =
  'Medical equipment has been successfully deleted!'
export const MEDICAL_EQUIPMENT_DELETE_MESSAGE = 'Delete medical equipment?'

export const FACILITY_MANAGMENT_SAVE_MESSAGE =
  'Facility has been successfully saved!'
export const FACILITY_MANAGMENT_UPDATE_MESSAGE =
  'Facility has been successfully updated!'

export const FLOOR_MANAGMENT_SAVE_MESSAGE = 'Floor has been successfully saved!'
export const FLOOR_MANAGMENT_UPDATE_MESSAGE =
  'Floor has been successfully updated!'

export const ROOM_MANAGMENT_SAVE_MESSAGE = 'Room has been successfully saved!'
export const ROOM_MANAGMENT_UPDATE_MESSAGE =
  'Room has been successfully updated!'

export const RECORD_CONFIRM_DELETE_MESSAGE =
  'Are you sure you want to delete the record?'

export const FOUR_DIGITS_MASK_WITH_DOT_INPUT_MESSAGE =
  'Put four Only two digits are alowed aftrer dot.'

export const MONTH_FILTER_TOOLTIP =
  'It shows all billing cycles that ends in the selected month'

export const REFERRAL_SOURCE_SAVE_MESSAGE =
  'Referral source has been successfully saved!'
export const REFERRAL_SOURCE_UPDATE_MESSAGE =
  'Referral source has been successfully updated!'
export const REFERRAL_SOURCE_DELETE_MESSAGE =
  'Referral source has been successfully deleted!'
export const REFERRAL_SOURCE_CONFIRM_DELETE_MESSAGE = `Are you sure you want to delete {:name}?`

export const PROVIDER_PORTAL_SAVE_MESSAGE =
  'Provider has been successfully saved!'
export const PROVIDER_PORTAL_UPDATE_MESSAGE =
  'Provider has been successfully updated!'
export const PROVIDER_PORTAL_DELETE_MESSAGE =
  'Provider has been successfully deleted!'
export const PROVIDER_PORTAL_CONFIRM_DELETE_MESSAGE = `Are you sure you want to delete {:name}?`
export const PROVIDER_PORTAL_RESET_PASSWORD_MESSAGE =
  "Provider's password has been successfully updated!"

export const RTM_INCLUDED_MESSAGE = 'RTM'

export const QUICK_MESSAGES_MANAGEMENT_SAVE_MESSAGE =
  'Quick message has been successfully saved!'
export const QUICK_MESSAGES_MANAGEMENT_UPDATE_MESSAGE =
  'Quick message has been successfully updated!'
export const QUICK_MESSAGES_MANAGEMENT_DELETE_MESSAGE =
  'Quick message has been successfully deleted!'
export const QUICK_MESSAGES_MANAGEMENT_CONFIRM_DELETE_MESSAGE = `Are you sure you want to delete {:name}?`
export const QUICK_MESSAGES_MANAGEMENT_DISABLE_ADD_BUTTON =
  'The limit is 10 messages, please update existing ones.'
export const QUICK_MESSAGES_MANAGEMENT_TEXT_INFO =
  "English version of the message is displayed in the column. The message will be sent in the recipient's primary language. Please add the translations, otherwise English version would be sent."
export const QUICK_MESSAGES_SEND_MESSAGE = 'Message has been successfully sent!'

export const TEXT_30_LENGTH_MESSAGE =
  'Text cannot be longer than 30 characters.'
export const TEXT_144_LENGTH_MESSAGE =
  'Text cannot be longer than 144 characters.'

export const ASSIGN_CAREGIVER_DISABLE_BUTTON_MESSAGE =
  'You need to assign a referral source to the patient before assigning caregiver.'
export const PATIENT_REFERRAL_SOURCE_DISABLE_SELECT_MESSAGE =
  'You need to remove all assigned caregivers before changing the referral source.'
export const CAREGIVER_REFERRAL_SOURCE_DISABLE_SELECT_MESSAGE =
  'You need to remove all assigned patients before changing the referral source.'

export const AGENCY_CASE_MANAGEMENT_SUCCESS_SAVE_MESSAGE =
  'Agency case manager has been successfully saved!'
export const NOTIFICATION_SEARCH_POPOVER_MESSAGE =
  'Not applicable to the previous period, available only for the current periods.'

export const DAYS_LEFT_MESSAGE =
  'Days left exclude today if measurement(s) were completed today.'

export const NOTIFICATION_TYPE_WARNING_MESSAGE =
  "Be aware that the patient won't receive a notification as the notifications are turned off."

export const NEXT_CALL_DATE_ERROR_MESSAGE = 'Date should be later than today.'

export const ONE_DATE_ERROR_MESSAGE = 'Please select date.'

export const PHONE_GENERATE_ERROR_MESSAGE =
  'Mobile phone number that starts with 000 cannot be set manually. Please click generate mobile phone button to have such a number.'
export const PHONE_GENERATE_ENABLED_MESSAGE =
  'Create a system-generated number.'

export const BY_PASS_INFO_MESSAGE =
  'Use the confirmation code for the phone number validation in the mobile app.'

export const APPOINTMENT_NOTIFICATION_TYPE_WARNING_MESSAGE =
  'Be aware that a person who is planning to have a ‘Call with’ won’t receive a notification as the notification is turned off.'

export const INVALID_TIME_FORMAT_BASE = "The time can't be set later than now"

export const INVALID_START_TIME_FORMAT =
  "The start time can't be set later than now + 10 min."

export const SAME_PATIENTS_MESSAGE =
  'A patient with the same name and DOB already exists in the system. Are you sure you want to create a duplicate patient?'

export const REPORT_SUCCESS_UPLOAD_MESSAGE =
  'We are working on your request, when completed an email with the report will be sent to your email address.'

export const FIELD_IS_NOT_VALID_MESSAGE = 'Field is not valid'

export const SEND_SMS_TITLE =
  'Add phone number to send sms with the urgent care invitation link'
export const SEND_EMAIL_TITLE =
  'Add an email address to send email with the urgent care invitation link'

export const VIDEO_CONFERENCE_WAITING_MESSAGE =
  'Please wait until your other party is joining'
export const VIDEO_CONFERENCE_JOIN_MESSAGE = 'Please wait, joining'

export const DISCHARGE_ENROLLMENT_MESSAGE =
  'By discharging the patient all active programs will automatically be closed. Do you want to proceed?'

export const ACTIVITY_MODAL_WARNING_MESSAGE =
  'Your timer is currently running for a different patient. Do you want to stop the timer?'
export const ACTIVITY_TIMER_PROGRAM_NOT_ACTIVE_MESSAGE =
  "The activity timer can't be started because the patient's billing program is not active yet."
export const CREATE_PENDING_USER_INFO_MESSAGE =
  'Your request has been successfully submitted. Your new user is currently in pending status. Our support team will review your request within 1 business day.'

export const MEDICAL_DEVICE_ORDERING_SAVE_ORDER_MESSAGE =
  'Medical device order has been successfully saved!'
export const MEDICAL_DEVICE_ORDERING_CANCEL_ORDER_MESSAGE =
  'Medical device order has been successfully canceled!'
export const MEDICAL_DEVICE_ORDERING_CANCEL_ORDER_WARNING_MESSAGE =
  'Make sure to add the following changes to the third-party service. Do you want to cancel the order?'
export const MEDICAL_DEVICE_ORDERING_CANCEL_ORDER_UPDATE_MESSAGE =
  'Make sure to add the following changes to the third-party service.'
export const MEDICAL_DEVICE_ORDERING_CANCEL_CONFIRM_MESSAGE =
  'Do you want to cancel the order?'

export const PATIENT_MEDICAL_DEVICE_DISCHARGE_LIVECARE_CONFIRM_MESSAGE =
  'Do you really want to discharge LiveCare subscription?'
export const PATIENT_MEDICAL_DEVICE_DISCHARGE_LIVECARE_MESSAGE =
  'Livecare device has been discharged!'

export const CAMERA_PERMISSIONS_MESSAGE =
  "Video conference requires access to your camera and microphone. Click the camera blocked icon in your browser's address bar and reload the page."
export const IPHONE_CAMERA_PERMISSIONS_MESSAGE =
  'Video conference requires access to your camera and microphone. Reload the page and allow your camera and microphone permissions.'

export const CHECKING_EXPIRE_HOURS_ERROR_MESSAGE =
  'Value must be between 1 - 1440.'

export const COMPLETE_DATE_ERROR_MESSAGE =
  'Date should be before activity date and later than today.'

export const REFERRAL_DELETE_ATTEMPT_CONFIRM_MESSAGE =
  'Are you sure you want to delete outreach attempt?'

export const PATIENT_CASE_MANAGER_UPDATE_MESSAGE =
  'Do you want to update the responsible party of the goal(s) and intervention(s) to the new case manager, where the current responsible party is the previous case manager or is not specified?'
export const PATIENT_CARE_TEAM_UPDATE_MESSAGE =
  'By saving the changes, the system will update all patients with the respective new settings. (Organization, Provider, Clinician, Group, Case Manager)'

export const INSURANCE_INFO_REFERRAL_MESSAGE =
  'Use this filter to search for referrals based on any insurance information they have.'
export const INSURANCE_INFO_PATIENT_MESSAGE =
  'Use this filter to search for patients based on any insurance information they have.'

export const LINK_COPY_MESSAGE = 'Link copied to the clipboard.'
export const PIN_COPY_MESSAGE = 'PIN-code copied to the clipboard.'
export const PASSWORD_COPY_MESSAGE = 'Password copied to the clipboard.'

export const COMPLETED_CALL_NOT_AVAILABLE_MESSAGE =
  'Available for Scheduled and In Progress calls only.'
export const NOT_VIDEO_VISIT_MESSAGE =
  'This appointment is not configured as a video visit'
export const PATIENT_LIVECARE_DEVICE_MESSAGE = 'Patient has livecare device.'
export const NO_RECIPIENTS_MESSAGE =
  'No available recipients for the SMS notification.'

export const RPM_BILLABLE_FILTER_EXPLAINER =
  "Use the filter to view patients based on their 'RPM Billable' status, set during patient enrollment. Select 'RPM Billable' to exclusively display patients marked as RPM billable."

export const URGENT_CARE_REPORT_MANAGEMENT_PASSWORD_CHANGE =
  'New password will work only for new exports. Are you sure you want to continue?'

export const ACTIVE_ACTIONS_MESSAGE = (activeActions = 0) =>
  `You have ${activeActions} active actions.`

export const INSURANCE_PROGRAM_TYPE_VALIDATION_MESSAGE =
  'Select Category or Insurance Program Type.'

export const EMAIL_LENGTH_ERROR_MESSAGE = 'Add at least one email.'
export const EDAN_FIELD_ERROR_MESSAGE =
  'Device name should consist of A-Z letters 0-9 digits, dash - and underscore _'

export const REFERRAL_SUBGROUP_NOT_AVAILABLE_MESSAGE =
  'No referral source sub-groups available'

export const NO_CLINICIANS_MESSAGE =
  'There are no Billing Clinicians for the patient’s provider. Please add a clinician before proceeding.'
export const NOT_LINKED_CLINICIAN_MESSAGE =
  'Selected Billing Clinician is not linked to the patient’s assigned provider.'

export const URL_VALIDATION_SIMPLE_MESSAGE =
  'URL must start with http:// or https://'

export const CLINNICIAN_CHANGE_WARNING =
  'Important! All scheduled appointments for the patient will be reassigned to a new clinician.'

export const CLINNICIAN_CHANGE_INFO =
  'This patient has scheduled appointments with clinicians from a different facility. Changing the facility will reassign these appointments to another clinician. Please assign the appointments to a new clinician or cancel the action.'

export const CHECKBOX_GROUP_REQUIRED_MESSAGE =
  'Choose at least one of the available options to continue.'
export const RADIO_REQUIRED_MESSAGE =
  'Choose one of the available options to continue.'
export const SUPPORT_USER_DISABLED_MSSAGE =
  'Support user role cannot log activity.'
